/* eslint-disable import/prefer-default-export */

// Converts snake-case/snake_case to camelCase
function toCamelCase(s) {
  return s
    .replace(/([-_][a-z])/ig, ($1) => $1.toUpperCase()
      .replace('-', '')
      .replace('_', ''));
}

export default toCamelCase;
